import {OrdersFeeResponse} from "../types/ApiResponseTypes";
import { atom } from 'jotai/index';

export const stxPriceAtom = atom<string>('');
